import { useEffect, useState } from "react";
import {
  Input,
  Header,
  FormField,
  SpaceBetween,
  Container,
  ColumnLayout,
  Box,
  Button,
} from "@cloudscape-design/components-themed";
import { LABELS, PLACE_HOLDERS } from "./constants";
import { RegisterAddressInfo } from "../../../features/api-interfaces";
import {
  isNull,
  isLengthValid,
  isHalfNumberValid,
} from "../../../utils/inputValidation";
import { getMessage } from "../../../features/error/messages";
import { COMMON_LABELS } from "../../default-constants";

// 郵便番号の入力チェック
export const checkPostalCode = (target: string, paramSetErrorMsg: any) => {
  const label = LABELS.CORP_POSTAL_CODE;
  const setErrorMsg = paramSetErrorMsg;
  // 必須
  if (isNull(target)) {
    setErrorMsg(getMessage("KGRERR055").label);
    return false;
  }
  // 文字長
  if (!isLengthValid(target, 7)) {
    setErrorMsg(getMessage("KGRERR059", 7).label);
    return false;
  }
  // 半角数値
  if (!isHalfNumberValid(target)) {
    setErrorMsg(getMessage("KGRERR006", label).label);
    return false;
  }
  setErrorMsg("");
  return true;
};

// 住所項目(必須項目)の入力チェック
export const checkRequiredAddressColumn = (
  target: string,
  paramSetErrorMsg: any
) => {
  const setErrorMsg = paramSetErrorMsg;
  // 必須
  if (isNull(target)) {
    setErrorMsg(getMessage("KGRERR055").label);
    return false;
  }
  // 文字長
  if (!isLengthValid(target, 100)) {
    setErrorMsg(getMessage("KGRERR058", 100).label);
    return false;
  }
  setErrorMsg("");
  return true;
};

// 住所その他の入力チェック
export const checkNotRequiredAddressColumn = (
  target: string,
  paramSetErrorMsg: any
) => {
  const setErrorMsg = paramSetErrorMsg;
  // 必須じゃないのでnullの場合はtrue
  if (isNull(target)) {
    return true;
  }
  // 文字長
  if (!isLengthValid(target, 100)) {
    setErrorMsg(getMessage("KGRERR058", 100).label);
    return false;
  }
  setErrorMsg("");
  return true;
};

// 電話番号の入力チェック
export const checkPhoneNumber = (target: string, paramSetErrorMsg: any) => {
  const setErrorMsg = paramSetErrorMsg;
  // 必須
  if (isNull(target)) {
    setErrorMsg(getMessage("KGRERR055").label);
    return false;
  }
  // 文字長
  if (!isLengthValid(target, 13)) {
    setErrorMsg(getMessage("KGRERR059", 13).label);
    return false;
  }
  // 半角数値
  if (!isHalfNumberValid(target)) {
    setErrorMsg(getMessage("KGRERR006").label);
    return false;
  }
  setErrorMsg("");
  return true;
};

// 登録時のチェック用に値とset関数を共通化
// 郵便番号
let registerCheckPostalCode = "";
const setRegisterCheckPostalCode = (value: string) => {
  registerCheckPostalCode = value;
};
export let registerCheckPostalCodeErrorMsg = "";
const setRegisterCheckPostalCodeErrorMsg = (value: any) => {
  registerCheckPostalCodeErrorMsg = value;
};
// 住所1
let registerCheckAddress1 = "";
const setRegisterCheckAddress1 = (value: string) => {
  registerCheckAddress1 = value;
};
let registerCheckAddress1ErrorMsg = "";
const setRegisterCheckAddress1ErrorMsg = (value: any) => {
  registerCheckAddress1ErrorMsg = value;
};

// 住所1カナ
let registerCheckAddress1Kn = "";
const setRegisterCheckAddress1Kn = (value: string) => {
  registerCheckAddress1Kn = value;
};
let registerCheckAddress1KnErrorMsg = "";
const setRegisterCheckAddress1KnErrorMsg = (value: any) => {
  registerCheckAddress1KnErrorMsg = value;
};

// 住所2
let registerCheckAddress2 = "";
const setRegisterCheckAddress2 = (value: string) => {
  registerCheckAddress2 = value;
};
let registerCheckAddress2ErrorMsg = "";
const setRegisterCheckAddress2ErrorMsg = (value: any) => {
  registerCheckAddress2ErrorMsg = value;
};

// 住所2カナ
let registerCheckAddress2Kn = "";
const setRegisterCheckAddress2Kn = (value: string) => {
  if (value !== null) {
    registerCheckAddress2Kn = value;
  }
};
let registerCheckAddress2KnErrorMsg = "";
const setRegisterCheckAddress2KnErrorMsg = (value: any) => {
  registerCheckAddress2KnErrorMsg = value;
};

// 電話番号
let registerCheckPhoneNumber = "";
const setRegisterCheckPhoneNumber = (value: string) => {
  registerCheckPhoneNumber = value;
};
let registerCheckPhoneNumberErrorMsg = "";
const setRegisterCheckPhoneNumberErrorMsg = (value: any) => {
  registerCheckPhoneNumberErrorMsg = value;
};

// 所在地情報
export let registerAddressData = {
  postalCode: "",
  address1: "",
  address1Kn: "",
  address2: "",
  address2Kn: "",
  prfCd: "",
  ctyCd: "",
  lrgCd: "",
  chrCd: "",
  phoneNumber: "",
} as RegisterAddressInfo;

const setRegisterAddressInfoData = (value: RegisterAddressInfo) => {
  registerAddressData = value;
};

export const AddressUI = (props: any) => {
  const [registerAddressData, setRegisterAddressData] = useState({
    postalCode: "",
    address1: "",
    address1Kn: "",
    address2: "",
    address2Kn: "",
    prfCd: "",
    ctyCd: "",
    lrgCd: "",
    chrCd: "",
    phoneNumber: "",
  } as RegisterAddressInfo);

  // 郵便番号
  const [postalCodeErrorMsg, setPostalCodeErrorMsg] = useState("");
  setRegisterCheckPostalCode(registerAddressData.postalCode);
  setRegisterCheckPostalCodeErrorMsg(setPostalCodeErrorMsg);

  // 住所1
  const [address1ErrorMsg, setAddress1ErrorMsg] = useState("");
  setRegisterCheckAddress1(registerAddressData.address1);
  setRegisterCheckAddress1ErrorMsg(setAddress1ErrorMsg);
  // 住所1カナ
  const [address1KnErrorMsg, setAddress1KnErrorMsg] = useState("");
  setRegisterCheckAddress1Kn(registerAddressData.address1Kn);
  setRegisterCheckAddress1KnErrorMsg(setAddress1KnErrorMsg);

  // 住所2
  const [address2ErrorMsg, setAddress2ErrorMsg] = useState("");
  setRegisterCheckAddress2(registerAddressData.address2);
  setRegisterCheckAddress2ErrorMsg(setAddress2ErrorMsg);
  // 住所2カナ
  const [address2KnErrorMsg, setAddress2KnErrorMsg] = useState("");
  setRegisterCheckAddress2Kn(registerAddressData.address2Kn);
  setRegisterCheckAddress2KnErrorMsg(setAddress2KnErrorMsg);

  // 電話番号
  const [phoneNumberErrorMsg, setPhoneNumberErrorMsg] = useState("");
  setRegisterCheckPhoneNumber(registerAddressData.phoneNumber);
  setRegisterCheckPhoneNumberErrorMsg(setPhoneNumberErrorMsg);

  // 住所情報の登録
  setRegisterAddressInfoData(registerAddressData);

  useEffect(() => {
    setRegisterAddressData(props.addressData);
  }, [props.addressData]);

  return (
    <Container header={<Header variant="h2">{LABELS.CORP_SUB_TITLE}</Header>}>
      <SpaceBetween direction="vertical" size="l">
        <ColumnLayout columns={5}>
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.CORP_POSTAL_CODE}</Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
            stretch={true}
            errorText={postalCodeErrorMsg}
            constraintText="半角数字7桁"
          >
            <ColumnLayout columns={5}>
              <Input
                value={registerAddressData.postalCode}
                placeholder={PLACE_HOLDERS.CORP_POSTAL_CODE}
                onChange={(event) => {
                  setRegisterAddressData({
                    ...registerAddressData,
                    postalCode: event.detail.value,
                  });
                  // コールバックチェック関数
                  checkPostalCode(event.detail.value, setPostalCodeErrorMsg);
                  props.setIsFormEntered(true);
                }}
              />
              <Button
                formAction="none"
                variant="normal"
                onClick={props.onClickPostalCodeSearch}
              >
                {LABELS.POSTAL_CODE_SEARCH}
              </Button>
            </ColumnLayout>
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={2}>
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.ADDRESS1}</Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
            stretch={true}
            errorText={address1ErrorMsg}
            constraintText="100文字以内"
          >
            <Input
              value={registerAddressData.address1}
              onChange={(event) => {
                setRegisterAddressData({
                  ...registerAddressData,
                  address1: event.detail.value,
                });
                // コールバックチェック関数
                checkRequiredAddressColumn(
                  event.detail.value,
                  setAddress1ErrorMsg
                );
                props.setIsFormEntered(true);
              }}
              readOnly
            />
          </FormField>
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.ADDRESS1_KANA}</Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
            stretch={true}
            errorText={address1KnErrorMsg}
            constraintText="100文字以内"
          >
            <Input
              value={registerAddressData.address1Kn}
              onChange={(event) => {
                setRegisterAddressData({
                  ...registerAddressData,
                  address1Kn: event.detail.value,
                });
                // コールバックチェック関数
                checkRequiredAddressColumn(
                  event.detail.value,
                  setAddress1KnErrorMsg
                );
                props.setIsFormEntered(true);
              }}
              disabled={!props.isInputEditable}
            />
          </FormField>
        </ColumnLayout>
        <ColumnLayout columns={2}>
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.ADDRESS2}</Box>
              </SpaceBetween>
            }
            stretch={true}
            errorText={address2ErrorMsg}
            constraintText="100文字以内"
          >
            <Input
              value={registerAddressData.address2}
              onChange={(event) => {
                setRegisterAddressData({
                  ...registerAddressData,
                  address2: event.detail.value,
                });
                props.setIsFormEntered(true);
              }}
              disabled={!props.isInputEditable}
              readOnly={!props.isUpdatable}
            />
          </FormField>
          {props.isUpdatableAddressKana2 ? (
            <FormField
              label={
                <SpaceBetween direction="horizontal" size="xs">
                  <Box variant="strong">{LABELS.ADDRESS2_KANA}</Box>
                </SpaceBetween>
              }
              stretch={true}
              errorText={address2KnErrorMsg}
              constraintText="100文字以内"
            >
              <Input
                value={registerAddressData.address2Kn}
                onChange={(event) => {
                  setRegisterAddressData({
                    ...registerAddressData,
                    address2Kn: event.detail.value,
                  });
                  props.setIsFormEntered(true);
                }}
                disabled={!props.isInputEditable}
                readOnly={!props.isUpdatable}
              />
            </FormField>
          ) : (
            <></>
          )}
        </ColumnLayout>
        <ColumnLayout columns={5}>
          <FormField
            label={
              <SpaceBetween direction="horizontal" size="xs">
                <Box variant="strong">{LABELS.CORP_TEL}</Box>
                <Box variant="small" color="text-status-error">
                  {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                </Box>
              </SpaceBetween>
            }
            stretch={true}
            errorText={phoneNumberErrorMsg}
            constraintText="半角数字13桁以内"
          >
            <Input
              value={registerAddressData.phoneNumber}
              placeholder={PLACE_HOLDERS.CORP_TEL}
              onChange={(event) => {
                setRegisterAddressData({
                  ...registerAddressData,
                  phoneNumber: event.detail.value,
                });
                // コールバックチェック関数
                checkPhoneNumber(event.detail.value, setPhoneNumberErrorMsg);
                props.setIsFormEntered(true);
              }}
              disabled={!props.isInputEditable}
            />
          </FormField>
        </ColumnLayout>
      </SpaceBetween>
    </Container>
  );
};

export const checkAddress = () => {
  let checkResult = true;
  if (
    !checkPostalCode(registerCheckPostalCode, registerCheckPostalCodeErrorMsg)
  ) {
    checkResult = false;
  }
  if (
    !checkRequiredAddressColumn(
      registerCheckAddress1,
      registerCheckAddress1ErrorMsg
    )
  ) {
    checkResult = false;
  }
  if (
    !checkRequiredAddressColumn(
      registerCheckAddress1Kn,
      registerCheckAddress1KnErrorMsg
    )
  ) {
    checkResult = false;
  }
  if (
    !checkNotRequiredAddressColumn(
      registerCheckAddress2,
      registerCheckAddress2ErrorMsg
    )
  ) {
    checkResult = false;
  }
  if (
    !checkNotRequiredAddressColumn(
      registerCheckAddress2Kn,
      registerCheckAddress2KnErrorMsg
    )
  ) {
    checkResult = false;
  }
  if (
    !checkRequiredAddressColumn(
      registerCheckAddress1Kn,
      registerCheckAddress1KnErrorMsg
    )
  ) {
    checkResult = false;
  }
  if (
    !checkPhoneNumber(
      registerCheckPhoneNumber,
      registerCheckPhoneNumberErrorMsg
    )
  ) {
    checkResult = false;
  }
  return checkResult;
};
